import {httpGet, httpPut, httpDelete, httpPost, httpDownload} from '../../../util/request.js';
import appConfig from '../../../config';

export default class AppointmentApi {
    static baseUrl = appConfig.gatewayUrl+appConfig.appointmentServicePath;
    // static baseUrl = "http://localhost:20065/appointment-service";

    static insert(param){
        return httpPost(this.baseUrl + "/appointment/insert", param);
    }

    static list(param){
        return httpPost(this.baseUrl + "/appointment/list", param);
    }

    static batchAudit(param){
        return httpPost(this.baseUrl + "/appointment/batchAudit", param);
    }

    static updateCar(param){
        return httpPost(this.baseUrl + "/appointment/updateCar", param);
    }

    static get(param){
        return httpGet(this.baseUrl + "/appointment/get", param);
    }

    static audit(param){
        return httpPost(this.baseUrl + "/appointment/audit", param);
    }

    static withdraw(param){
        return httpPost(this.baseUrl + "/appointment/withdraw", param);
    }

    static cancel(param){
        return httpPost(this.baseUrl + "/appointment/cancel", param);
    }

    static update(param){
        return httpPost(this.baseUrl + "/appointment/update", param);
    }

    static dischargeType(param){
        return httpGet(this.baseUrl + "/appointment/discharge-type", param);
    }

    static cancelAudit(param){
        return httpPost(this.baseUrl + "/appointment/cancelAudit", param);
    }
}